import { useField } from 'formik'
import { FC } from 'react'

import { RadioButtonGroup, RadioButtonGroupProps, RadioButtonOption } from './RadioButtonGroup'

type RadioButtonGroupFieldProps = Omit<RadioButtonGroupProps, 'value' | 'onChange' | 'onBlur'> & {
  onChange?: (value: RadioButtonOption['value']) => void
}

const RadioButtonGroupField: FC<RadioButtonGroupFieldProps> = ({ onChange, ...props }) => {
  const [field, , helper] = useField(props.name)

  const handleChange = (value: RadioButtonOption['value']) => {
    helper.setValue(value)
    onChange?.(value)
  }

  return (
    <RadioButtonGroup
      {...props}
      {...field}
      onChange={handleChange}
    />
  )
}

export type { RadioButtonGroupFieldProps }

export { RadioButtonGroupField }
